import React from 'react';
import { Helmet } from 'react-helmet-async';
import { runtime } from '../data/runtime';
import { useSite } from '../content/SiteContext';
const { SITE_URL } = runtime;

const Seo = ({ title: baseTitle, description: baseDescription, path = '/', noindex: baseNoindex = false, image: baseImage = runtime.BUSINESS.ogImage, jsonLd = [] }) => {
  // Per-path overrides published from the CMS SEO screen win over page defaults.
  const o = useSite().getSeo?.(path) || {};
  const title = o.title || baseTitle;
  const description = o.description || baseDescription;
  const noindex = o.noindex || /noindex/i.test(o.robots || '') || baseNoindex;
  const image = o.ogImage || baseImage;
  const url = o.canonical || `${SITE_URL}${path === '/' ? '/' : path}`;
  return (
    // defer={false}: apply head tags synchronously so pre-rendering captures them.
    <Helmet defer={false}>
      <html lang="en" dir="ltr" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large'} />
      {!noindex && <link rel="canonical" href={url} />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={runtime.BUSINESS.name} />
      <meta property="og:locale" content="en_AE" />
      <meta property="og:title" content={o.ogTitle || title} />
      <meta property="og:description" content={o.ogDescription || description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={o.ogTitle || title} />
      <meta name="twitter:description" content={o.ogDescription || description} />
      <meta name="twitter:image" content={image} />
      {jsonLd.filter(Boolean).map((data, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(data)}</script>
      ))}
    </Helmet>
  );
};

export default Seo;
